import { Box, FormControlLabel, Checkbox, Collapse } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import pt from "date-fns/locale/pt";
import { Controller, UseFormReturn } from "react-hook-form";
import { CustomEventType } from "../../utils/types";
import { ScheduleActionFormData } from "./types";

type RepeatUntilDateProps = {
    formMethods: UseFormReturn<ScheduleActionFormData>;
    watchedValues: ScheduleActionFormData;
    selectedEvents: Array<CustomEventType>;
};

export const RepeatUntilDate = ({
    formMethods,
    watchedValues,
    selectedEvents,
}: RepeatUntilDateProps) => {
    const handleCheckboxChange = (isChecked: boolean) => {
        formMethods.setValue("applyToMatchingSlots", isChecked);
        if (isChecked && !watchedValues.matchingEndDate && selectedEvents.length > 0) {
            const firstEventDate = new Date(selectedEvents[0].start);
            formMethods.setValue("matchingEndDate", firstEventDate);
        }
    };

    return (
        <Box mb={1}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={watchedValues.applyToMatchingSlots}
                        onChange={(e) => handleCheckboxChange(e.target.checked)}
                        size="small"
                    />
                }
                label="Repetir alterações até"
                sx={{ ml: 0 }}
            />
            <Collapse in={watchedValues.applyToMatchingSlots}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pt}>
                    <Controller
                        name="matchingEndDate"
                        control={formMethods.control}
                        render={({ field }) => (
                            <DatePicker
                                label="Data final"
                                onChange={(date) => field.onChange(date)}
                                value={field.value}
                                format="dd/MM/yyyy"
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true,
                                    },
                                }}
                            />
                        )}
                    />
                </LocalizationProvider>
            </Collapse>
        </Box>
    );
};

